import React from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Input, LoginBox, LoginContainer, Title } from "../../signatures/loginSignatures/styles";

const LoginAnticipationFee: React.FC = () => {
  const [password, setPassword] = React.useState('');
  const history = useHistory();

  const predefinedPassword = '9yTr8L$4p:*4>]g';

  const handleLogin = () => {
    if(password === predefinedPassword){
      history.push('/admin/cadastrar-taxas-antecipacao')
    } else {
      toast.error("Senha incorreta!");
    }
  };

  return(
    <LoginContainer>
      <LoginBox>
        <Title>Login Cadastro Taxas Antecipação Pontual</Title>
        <Input
          type="password"
          placeholder="Insira a senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button onClick={handleLogin}>Entrar</Button>
      </LoginBox>
    </LoginContainer>
  )
}

export default LoginAnticipationFee;